import * as React from 'react';
import Cookies from 'js-cookie';
import CargoChargesSearchBar from '../CargoChargesSearchBar';
import { Row, Col, Form, message, Button } from 'antd';
import CargoChargesResults from '../CargoChargesResults';
import { CargoChargesHandler } from './CargoChargesFormHandler';
import { FormComponentProps } from 'antd/lib/form';
import { RouteComponentProps, withRouter, NavLink } from 'react-router-dom';
import CargoChargesSearchModel from '../CargoChargesSearchBar/CCSearchBarModel';
import { StyleCargoChargesRow } from '../CargoCharges.Style';
import CargoChargesResultModel from '../CargoChargesResults/CargoChargesResultsModel';
import moment, { Moment } from 'moment';
import Utility from 'Core/Utility';
import AuthContext from 'Context/AuthContext';
import NotificationUtility from 'Core/NotificationUtility';
import ConfigUtility from 'Core/ConfigUtility';
import ProceedToCartButton from './ProceedToCartButton';
import * as QueryString from "query-string";

export interface Props extends FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
  checkoutButtonRoute?: string;
  hideCheckoutButton?: boolean;
}

export interface State {
  results: Array<CargoChargesResultModel>;
  customerCodebolNo?: string

}

class BaseCargoChargesForm extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;
  cargoChargesHandler: CargoChargesHandler;
  retainBOLCookieName: string;

  bolQueryParamName = 'boln';

  constructor(props: Props) {
    super(props);
    this.cargoChargesHandler = new CargoChargesHandler(props);
    this.SearchBar_Search = this.SearchBar_Search.bind(this);
    this.removeShipment = this.removeShipment.bind(this);
    this.goToCartPage = this.goToCartPage.bind(this);
    this.retainBOLCookieName = '';
    this.state = {
      results: [],
    };
  }

  componentDidMount() {
    const queryData = new URLSearchParams(this.props.location.search);

    if (queryData.has(this.bolQueryParamName) && queryData.get(this.bolQueryParamName)) {
      const bolNumber = queryData.get(this.bolQueryParamName)!;
      const tomorrow = moment().add(1, "d");
      this.SearchBar_Search(bolNumber, tomorrow);

    }

    if (QueryString.parse(this.props.location.search) !== undefined) {
      const { bolNo } = QueryString.parse(this.props.location.search);
      if (bolNo != null || bolNo != undefined) {
        let tempDate = moment();
        this.SearchBar_Search(bolNo, tempDate);
        this.setState({ customerCodebolNo: bolNo })
      }
      else {
        //NotificationUtility.error("No Bill of Laden with that number found.", "", 30, true);
        //TODO: CHANGE TO CLICK N GO PAGE WHEN IT IS OFFICIALLY CREATED
        // this.props.history.push("/home");
      }
    }

  }

  //remember to pass data down
  SearchBar_Search(bolNumber: string, storageToDate: Moment) {
    var cargoSearch: CargoChargesSearchModel;
    cargoSearch = {
      bolNumber: this.state.customerCodebolNo ? this.state.customerCodebolNo : bolNumber,
      storageToDate: this.state.customerCodebolNo ? moment() : storageToDate,
    };

    this.cargoChargesHandler
      .GetBillOfLadingCharges(cargoSearch)
      .then(foundBol => {
        const { results } = this.state;
        const existingBol = results.filter(x => x.bolNumber?.toLowerCase() === foundBol.bolNumber?.toLowerCase());
        var total = foundBol!.total ?? 0;
        foundBol.bolNumber = foundBol.bolNumber?.toUpperCase();
        if (foundBol && total <= 0) {
          // charge is 0, cannot add it.
          NotificationUtility.info(
            'Already Paid',
            `BOL ${foundBol.bolNumber?.toUpperCase()} has already been paid in full.`,
            25,
            true
          );
          if (existingBol?.length) {
            this.setState({ results: results.filter(x => x.bolNumber?.toLowerCase() !== foundBol.bolNumber?.toLowerCase()) })
          }
          return;
        }

        if (existingBol && existingBol.length > 0) {
          // was already in the list, updating the list
          const newList = results.filter(x => x.bolNumber !== foundBol.bolNumber);
          this.setState({ results: [...newList, foundBol] });
          // message.info(`Updated Shipment ${foundBol.bolNumber}`);
          NotificationUtility.info(
            'Shipment Updated',
            `Updated pick-up date for shipment with BOL ${foundBol.bolNumber?.toUpperCase()}.`,
            7,
            true
          );
        } else {
          this.setState({ results: [...results, foundBol] });
          if (!this.state.customerCodebolNo) {
            NotificationUtility.success(
              'Shipment Added To List',
              `New Shipment ${foundBol.bolNumber?.toUpperCase()} was added to list.`,
              7,
              true
            );
          }
        }
      })
      .catch(() => {
        NotificationUtility.error('No related BOLs found', '', 30, true)

      });
  }

  removeShipment(cargo: CargoChargesResultModel) {
    this.setState({ results: this.state.results.filter(x => x !== cargo) });
    NotificationUtility.info(
      'Shipment Removed To List',
      `Shipment ${cargo.bolNumber} was removed from the list.`,
      25,
      true
    );
  }

  colLayout = {
    lg: { span: 13 },
    sm: { span: 24 },
  };

  goToCartPage(): void {
    this.props.history.push(this.props.checkoutButtonRoute ?? '/cart');
  }

  async setRetainBOLCookieName() {
    const config = await ConfigUtility.get();
    this.retainBOLCookieName = config.RetainBOLsCookieName + '_' + this.context.data?.id;
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    // if (this.context.data?.id) {
    //   if (this.state.results.length > 0) {
    //     Cookies.set(this.retainBOLCookieName, Object.assign({}, this.state.results), { secure: true });
    //   }
    // } else {
    //   Cookies.remove(this.retainBOLCookieName);
    // }
  }



  render() {
    return (
      <>
        {this.state.customerCodebolNo ?
          null
          :
          <Row>
            <Col>
              <p>
                Have you registered a card? If you haven't, please register your card&nbsp;
                <NavLink to="/user-profile/register-card">here</NavLink>
              </p>
            </Col>
          </Row>
        }
        <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px 30px", marginTop: "5px" }}>
          <StyleCargoChargesRow>
            <Col>
              {this.state.customerCodebolNo ?
                null :
                <CargoChargesSearchBar search={this.SearchBar_Search} />
              }
              {/* result only appear when there is data to present */}
              <CargoChargesResults
                results={this.state.results}
                updatePickupDate={this.SearchBar_Search}
                removeShipment={this.removeShipment}
              />
            </Col>
          </StyleCargoChargesRow>
          <Row type="flex" justify="space-between">
            <Col />
            {!this.props.hideCheckoutButton &&
              <Col>
                <ProceedToCartButton goToCartPage={this.goToCartPage} />
              </Col>}
          </Row>
        </Row>
      </>
    );
  }
}

const CargoChargesFormWithoutRouter = Form.create<Props>({
  name: 'CargoChargesSearchBar',
})(BaseCargoChargesForm);

const CargoChargesForm = withRouter(CargoChargesFormWithoutRouter);

export default CargoChargesForm;
